// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "fallback" + "." + "526df9c8ae34cc8e5b72" + ".css";
};